import React, { ReactNode } from 'react';
import './Patterns.css';

export interface ComputedValueProps {
  /** Short text describing how the value is derived (e.g. "longest of all products"). */
  premise: ReactNode;
  /** The computed value (e.g. "14 days", "2 mixes", a numeric volume). */
  value: ReactNode;
}

const ComputedValue: React.FC<ComputedValueProps> = ({ premise, value }) => (
  <div className="pat-computed-value" role="status">
    <span className="pat-computed-value__premise">{premise}</span>
    <span className="pat-computed-value__value">{value}</span>
  </div>
);

export default ComputedValue;
